import React, { FC, useState } from 'react'
import { Button } from 'rsuite'
import { TypeAttributes } from 'rsuite/esm/@types/common'
import useTranslation from 'next-translate/useTranslation'
import dynamic from 'next/dynamic'

import useBuyerCatalogs from '../../services/useBuyerCatalogs'
import { useAuth } from '../../services/useAuth'
import useLoginModal from '../../services/useLoginModal'
import OrderListIcon from '../Icons/SavedProducts/CatalogIcon'
import OrderListIconHover from '../BuyerProfile/OrderListIconHover'
import { Product } from '../../utils/types/Product'
import { OrderListItem } from '../../utils/types/buyerCatalogs'

import styles from '../../styles/AddToOrderListButton.module.less'
import buttonStyles from '../../styles/CustomButtons.module.less'

const CatalogModal = dynamic(() => import('../Modals/CatalogModal'))

interface AddToOrderListButtonProps {
  product: Product
  hover?: boolean
  existingOrderList?: OrderListItem
  orderListName?: string
  className?: string
  appearance?: TypeAttributes.Appearance
  iconClassName?: string
  onSave?: () => void
  onClose?: () => void
}

const AddToOrderListButton: FC<AddToOrderListButtonProps> = (props) => {
  const {
    product,
    hover = false,
    existingOrderList,
    orderListName = null,
    className = '',
    appearance = 'ghost',
    iconClassName = '',
    onSave = () => {},
    onClose = () => {},
  } = props

  const { user } = useAuth()
  const { openLoginModal } = useLoginModal()

  const [showPickOrderListModal, setShowPickOrderListModal] = useState(false)
  const { t } = useTranslation('buyerProfile')

  const {
    isSaving,
  } = useBuyerCatalogs()

  const handleOnClick = () => {
    if (!user) {
      openLoginModal()
    } else {
      setShowPickOrderListModal(true)
    }
  }

  return (
    <>
      {existingOrderList ? (
        <Button
          appearance="ghost"
          className={`font-semibold wrap-text ${buttonStyles['custom-button']} ${buttonStyles['button-tertiary']} ${buttonStyles['button-caret']} ${className}`}
          loading={isSaving}
          onClick={handleOnClick}
        >
          {t('Change quantity')}
        </Button>
      ) : (
        <Button
          data-testid="save-to-order-list-button"
          className={`${styles['save-to-order-list-button']} ${className}`}
          appearance={appearance}
          loading={isSaving}
          onClick={handleOnClick}
        >
          {hover
            ? (
              <OrderListIconHover className={iconClassName} />
            )
            : (
              <OrderListIcon className={iconClassName} />
            )}
        </Button>
      )}

      {showPickOrderListModal && (
        <CatalogModal
          product={product}
          existingOrderList={existingOrderList}
          catalogName={orderListName}
          onSave={onSave}
          setIsCatalogModalOpen={setShowPickOrderListModal}
          onClose={onClose}
        />
      )}
    </>
  )
}

export default AddToOrderListButton
